/* eslint semi: ["error", "never"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */
function Checkbox(_ref) {
  var name = _ref.name,
      value = _ref.value,
      _onChange = _ref.onChange,
      labelText = _ref.labelText,
      identifier = _ref.identifier;
  return React.createElement("div", {
    className: "checkbox-field ".concat(identifier)
  }, React.createElement("label", {
    htmlFor: identifier
  }, React.createElement("input", {
    type: "checkbox",
    name: name,
    id: identifier,
    checked: value,
    onChange: function onChange(event) {
      _onChange(name, event.target.checked);
    }
  }), React.createElement("span", null, labelText)));
}

Checkbox.defaultProps = {
  value: false
};
export default Checkbox;